import Slider from 'components/3catinfo/Slider';
import Camera from 'components/3catinfo/ElTemps/Camera';
import styles from './slidercameres.module.scss';

const SliderCameres = (props) => {
    const { items, titol } = props;

    return (
        <>
            {items && (
                <div className={styles.sliderCameres}>
                    <Slider format='cameres' fletxes='mig' estilModul='sliderCameres' titol={`Carrusel: ${titol}`} noTitol={true}>
                        {items.map((item, index) => {
                            return (
                                <div className={styles.camera} key={`slider-camera-${index}`}>
                                    <Camera item={item} index={index} items={items} />
                                </div>
                            );
                        })}
                    </Slider>
                </div>
            )}
        </>
    );
};

export default SliderCameres;
